import { render } from "./DesktopIcon.vue?vue&type=template&id=5990d53a&scoped=true"
import script from "./DesktopIcon.vue?vue&type=script&lang=js"
export * from "./DesktopIcon.vue?vue&type=script&lang=js"

import "./DesktopIcon.vue?vue&type=style&index=0&id=5990d53a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5990d53a"]])

export default __exports__